/** Shared geometry and seam treatment for the shell's app-level chrome rail. */
export const SHELL_APP_RAIL_CLASS =
  "h-12 min-h-12 shrink-0 border-b border-[var(--color-border-default)] bg-[var(--surface-sunken)]";

/**
 * Shared desktop geometry for controls docked above the global footer.
 *
 * The expanded sidebar footer contains the collapse and account rows. Mounted app
 * controls use the same fixed block size so their top borders form one continuous
 * shell seam even when one surface has additional status content. Mobile navigation
 * is a drawer, so compact app controls keep their natural height below the `md`
 * breakpoint.
 */
export const SHELL_BOTTOM_DOCK_CLASS =
  "md:h-[calc(6.25rem+1px)] md:min-h-[calc(6.25rem+1px)] md:max-h-[calc(6.25rem+1px)]";
